import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PRIVACY_ANONYMOUS_USERS = createFcmDetails('privacy_anonymous_users', {
	owner: 'Site Platform',
	context: 'APIs / security / safety',
	description: `
		Allows to specify a list of country codes (upper case) or user ids for which to enable user anonymization.

		Any user whose country (from their settings) is in the list of country codes or whose id is in the list of user ids will:
		- have their data anonymised (including their id) in all exposed APIs
		- appear as "Anonymous" to everyone except themselves, on all pages
		- have their /u/<id> page return a 404 except for themselves
		`,
	template: {
		countries: ['XX', 'YY'],
		users: ['123', '456'],
	},
	import: false,
});
